import { ListItemProps, ListProps } from './types';

const mainClass = 'List';

export const styleList = (props: ListProps) => {
  const mc = mainClass;
  const cls = [mc];
  if (props.size) {
    cls.push(`${mc}--${props.size}`);
  }
  return cls;
};

export const styleListItem = (props: ListItemProps) => {
  const mc = `${mainClass}Item`;
  const cls = {
    main: [mc],
    wrapper: [`${mc}__Wrapper`],
    inner: [`${mc}__Inner`],
    icon: [`${mc}__Icon`]
  };
  if (props.selected) {
    cls.main.push(`${mc}--selected`);
  }
  if (props.disabled) {
    cls.main.push(`${mc}--disabled`);
  }
  return cls;
};
